import React, { useState } from "react";
import { FaChevronDown, FaChevronUp, } from "react-icons/fa";
// import { RiCloseLargeFill } from "react-icons/ri";
import { TiArrowLeftThick } from "react-icons/ti";

import "../../Styles/Employeefilter.css";

function Tpofilter({ show = true, onClose = () => { } }) {

  const [openMenus, setOpenMenus] = useState({});



  const toggleMenu = (menu) => {
    setOpenMenus((prev) => ({ ...prev, [menu]: !prev[menu] }));

    onClose(false);
  };
  if (!show) return null;

  return (
    <div className={`admin-sidebar-filter `}>
      <div className="filter-sidebar-header">
        <button className="close-arrow" onClick={() => onClose(false)}>
          <TiArrowLeftThick />
        </button>
        <span className="filter-dashboard-tit">Filter</span>

      </div>

      <ul className="filter-sidebar-menu">


        {/* University/Autonomous */}
        <li>
          <div className="filter-menu-item" onClick={() => toggleMenu("contact")}>
            <span>University/Autonomous</span>
            {openMenus.contact ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          <ul className={`filter-submenu ${openMenus.contact ? "open" : ""}`}>
            <li className="filter-line-bottom">
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Acharya Nagarjuna University</spam>
              </div>
            </li>
            <li className="filter-line-bottom">

              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Jawahaelal Nehru Technological University</spam>
              </div>

            </li>
            <li className="filter-line-bottom">

              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Osmania University</spam>
              </div>

            </li>
            <li className="filter-line-bottom">

             
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Acharya Nagarjuna University, Guntur</spam>
              </div>

            </li>
            <li className="filter-line-bottom">
          
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Sri Venkateswara University, Tirupati</spam>
              </div>

            </li>

          </ul>
        </li>

        {/* College */}
        <li>
          <div
            className="filter-menu-item"
            onClick={() => toggleMenu("registration")}
          >
            <span>College</span>
            {openMenus.registration ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          <ul
            className={`filter-submenu ${openMenus.registration ? "open" : ""}`}
          >
            <li className="filter-line-bottom">
              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Government City College (AU)</spam>
              </div>

            </li>

            <li className="filter-line-bottom">
              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Vardhaman College of Engineering(AU)</spam>
              </div>

            </li>

            <li className="filter-line-bottom">
            
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Sri Harshini Degree College</spam>
              </div>

            </li>
            <li className="filter-line-bottom">
              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Kodad Intritute of technology and science for women</spam>
              </div>

            </li>
            <li className="filter-line-bottom">
              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Sri Gowthami Degree & PG College</spam>
              </div>

            </li>

          </ul>
        </li>

        {/* Designation */}
        <li>
          <div className="filter-menu-item" onClick={() => toggleMenu("jobs")}>
            <span>Designation</span>
            {openMenus.jobs ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          <ul className={`filter-submenu ${openMenus.jobs ? "open" : ""}`}>
            <li className="filter-line-bottom">
              

              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">TPO</spam>
              </div>

            </li>

            <li className="filter-line-bottom">
               
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Principal</spam>
              </div>

            </li>

            <li className="filter-line-bottom">
              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">HOD</spam>
              </div>

            </li>
            <li className="filter-line-bottom">
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Others</spam>
              </div>

            </li>

          </ul>
        </li>

        {/* Department */}
        <li>
          <div
            className="filter-menu-item"
            onClick={() => toggleMenu("permission")}>
            <span>Department</span>
            {openMenus.permission ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          <ul
            className={`filter-submenu ${openMenus.permission ? "open" : ""}`}
          >
            <li className="filter-line-bottom">
              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Information Technology</spam>
              </div>

            </li>

            <li className="filter-line-bottom">
               
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Academic Affairs</spam>
              </div>

            </li>

            <li className="filter-line-bottom">
               
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Master of Business Administration</spam>
              </div>

            </li>

            <li className="filter-line-bottom"> 

              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Student Welfare Department</spam>
              </div>

            </li>
            <li className="filter-line-bottom">
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Civil Engineering</spam>
              </div>
            </li>
          </ul>
        </li>

        {/* States */}
        <li>
          <div className="filter-menu-item" onClick={() => toggleMenu("services")}>
            <span>States</span>
            {openMenus.services ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          <ul className={`filter-submenu ${openMenus.services ? "open" : ""}`}>

            <li className="filter-line-bottom">
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Andhra pradesh</spam>
              </div>

            </li>


            <li className="filter-line-bottom">
                <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Telangana</spam>
              </div>
            </li>

            <li className="filter-line-bottom">
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Tamilnadu</spam>
              </div>

            </li>



            <li className="filter-line-bottom">
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Karnataka</spam>
              </div>
            </li>
          </ul>
        </li>

        <li>
          <ul >
            <label className="pin-text">Pincode</label>
            <li className="filter-line-bottom"><input type="text"></input></li>
          </ul>

        </li>
      </ul>
    </div>
  );
}

export default Tpofilter;
